<section class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea">
            <h2>{{ pageTitle.title }}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{ pageTitle.title }}</li>
                <li>{{ pageTitle.subTitle }}</li>
            </ul>
        </div>
    </div>
    <div class="shape-img1">
        <img src="assets/img/shape/shape1.svg" alt="image" />
    </div>
    <div class="shape-img2">
        <img src="assets/img/shape/shape2.png" alt="image" />
    </div>
    <div class="shape-img3">
        <img src="assets/img/shape/shape3.png" alt="image" />
    </div>
</section>

<section class="courses-details-area pb-100">
    <div class="container">
        @for(item of items; track item.id){
        <div class="row">
            <div class="col-lg-7 col-md-12">
                <div class="courses-details-desc">
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="overview" role="tabpanel">
                            <div class="demo-container">
                                <div class="row">
                                    <div class="col-lg-8 col-md-12">
                                        <h3>{{item.title}}</h3>
                                        <video width="640" height="360" controls>
                                            <source [src]="item.videoUrl" type="video/mp4">

                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-md-12">
                <div class="courses-details-info">
                    <div class="image">
                    </div>
                    <ul class="info">
                        <li>
                            <div class="justify-content-between ">
                                <span><i class="flaticon-idea"></i>Summary</span>
                                <p [innerHTML]="item.description"></p>
                            </div>
                        </li>
                        <li>
                            <div class="d-flex justify-content-between ">
                                <span><i class="flaticon-stopwatch"></i> Duration</span>
                                <p *ngIf="this.pageData == 'data-products'">{{item.duration}}</p>
                            </div>
                        </li>
                        <li>
                            <div class="d-flex justify-content-between ">
                                <span><i class="flaticon-web"></i> Date</span>
                                <p *ngIf="this.pageData == 'data-products'">{{item.recordedDate}}</p>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
        }
    </div>
</section>